"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var utils_1 = require("../../../core/utils");

var SelloutReleaseCategoryTotalDTO_1 = require("../../model/sellout/SelloutReleaseCategoryTotalDTO");

var SelloutImpactRecordConverter_1 = require("./SelloutImpactRecordConverter");

var SelloutReleaseCategoryTotalDTOConverter_1 = require("./SelloutReleaseCategoryTotalDTOConverter");
/**
 * @author JMr
 */


var SelloutReleaseCategoryTotalDTOConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseCatego) {
  _inherits(SelloutReleaseCategoryTotalDTOConverterImpl, _SelloutReleaseCatego);

  function SelloutReleaseCategoryTotalDTOConverterImpl(selloutImpactRecordConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseCategoryTotalDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryTotalDTOConverterImpl).call(this));
    _this.selloutImpactRecordConverter = selloutImpactRecordConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseCategoryTotalDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseCategoryTotalDTO_1.SelloutReleaseCategoryTotalDTO(source.productId, this.selloutImpactRecordConverter.toObject(source.impact, conversions), conversions.asObjectList(source, 'previousImpacts', function (impactDoc) {
        return _this2.selloutImpactRecordConverter.toObject(impactDoc, conversions);
      }), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), utils_1.Utils.isValueMissing(source.exportedCount) ? 0 : source.exportedCount, utils_1.Utils.isValueMissing(source.itemCount) ? 0 : source.itemCount, source.readonly);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var doc = {
        productId: source.productId,
        impact: this.selloutImpactRecordConverter.toDocument(source.impact, conversions),
        previousImpacts: conversions.asObjectArray(source, 'previousImpacts', function (impact) {
          return _this3.selloutImpactRecordConverter.toDocument(impact, conversions);
        }),
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions),
        exportedCount: source.exportedCount,
        itemCount: source.itemCount,
        readonly: source.readonly
      };
      return doc;
    }
  }]);

  return SelloutReleaseCategoryTotalDTOConverterImpl;
}(SelloutReleaseCategoryTotalDTOConverter_1.SelloutReleaseCategoryTotalDTOConverter);

SelloutReleaseCategoryTotalDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutImpactRecordConverter_1.SelloutImpactRecordConverter, ValidationResultConverter_1.ValidationResultConverter])], SelloutReleaseCategoryTotalDTOConverterImpl);
exports.SelloutReleaseCategoryTotalDTOConverterImpl = SelloutReleaseCategoryTotalDTOConverterImpl;